<template>
  <div class="mobile_login">
    <!-- <van-notify v-model="show" type="success">
      <van-icon name="bell" style="margin-right: 4px" />
      <span>登陆成功</span>
    </van-notify> -->
    <div style="padding-top:25%; background:#ff5421">
      <el-image style="width: 100px; height: 100px;"
                src="https://download.szsxsurf.com/logo.png"
                fit="fill"></el-image>
      <div style="text-align:center; padding:20px;color:#FFF; font-size:15px;">Booking/Product Manage</div>
      <!--  -->
      <van-field v-model="formData.username"
                 label="用户名" />
      <van-field v-model="formData.password"
                 type="password"
                 label="密码" />
      <van-row type="flex"
               justify="center">
        <van-col span="6"> </van-col>
      </van-row>
    </div>
    
    <div style="margin:10px">
      <van-button @click="loginSystem"
                  round
                  color="#ff5421"
                  type="info"
                  block
                  size="normal">登陆</van-button>
    </div>
    <!-- 版权 -->
    <div style="position:fixed; bottom:20px; width: 100%;"> Copyright © {{ year }} 南京速至所想旅游咨询有限公司
      <div>备案证书号： <a target="_blank"
           style="color: #ff5421"
           href="https://beian.miit.gov.cn/">
          苏ICP备20037515号
        </a> </div>
    </div>
  </div>
</template>

<script>
import { Field } from 'vant'
import { Button } from 'vant'
import { Col, Row } from 'vant'
import { Notify } from 'vant'
import { Base64 } from 'js-base64'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'm_login',
  components: {
    'van-field': Field,
    'van-button': Button,
    'van-col': Col,
    'van-row': Row,
    [Notify.Component.name]: Notify.Component,
  },
  data() {
    return {
      show: false,
      remember: true,
      formData: {
        username: '',
        password: '',
      },
      year: '',
    }
  },
  computed: {
    ...mapState(['hasLogin', 'userINfo']),
  },
  created() {
    // // 在页面加载时从cookie获取登录信息
    let username = this.$cookies.get('username')
    let password_base = this.$cookies.get('password')
    let password
    if (password_base) {
      password = Base64.decode(password_base)
    }
    // // 如果存在赋值给表单，并且将记住密码勾选
    if (username) {
      this.formData.username = username
      this.formData.password = password
      this.remember = true
    }
  },
  methods: {
    ...mapMutations(['login', 'logout']),

    loginSystem() {
      // 判断是否记住密码
      if (this.remember) {
        let password = Base64.encode(this.formData.password)
        this.setCookie(this.formData.username, password, 7)
      } else {
      }
      this.$http.post('/login', this.formData).then((res) => {
        // console.log('res')
        const { errmsg, errno, data } = res.data

        // this.$cookies.set("登陆时设置了一个cookie", res.headers);
        if (errno === '0') {
          this.login(data)
          // 成功通知
          Notify({ type: 'success', message: errmsg })

          this.$router.push({ path: '/m_product_list' })
        } else if (errno === '4101') {
          Notify({ type: 'error', message: errmsg })
        } else {
          Notify({ type: 'error', message: errmsg })
        }
      })
    },
    setCookie(userame, password, expiredays) {
      var exdate = new Date() // 创建时间对象
      exdate.setDate(exdate.getDate() + expiredays)

      this.$cookies.set('username', userame, exdate.toGMTString())
      this.$cookies.set('password', password, exdate.toGMTString())
    },
  },
  getYear() {
    this.year = new Date().getFullYear()
    // console.log(this.year);
  },
}
</script>

<style>
.mobile_login {
  text-align: center;
  height: 100%;
}
html,
body,
#app {
  height: 100%;
  background-color: #fff;
}
</style>